// extracted by mini-css-extract-plugin
export default {"heading":"bl_8","arrow":"bl_dk","header":"bl_1"};